import { useParams } from "react-router-dom";
import SnakeGame from "../games/SnakeGame/SnakeGame";
import MoveTac from "../games/MoveTac/MoveTac";

export default function GamePage() {
  const { gameId } = useParams();

  const games = {
    snake: <SnakeGame />,
    movetac: <MoveTac />,
  };

  return games[gameId] || <h2>Game not found</h2>;
}
